"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _reactCsv = require("react-csv");
var _jspdf = _interopRequireDefault(require("jspdf"));
var _classnames = _interopRequireDefault(require("classnames"));
require("jspdf-autotable");
require("react-table/react-table.css");
var _helpers = require("@qwkin/helpers");
var _mock = require("../../assets/mock");
var _Table = require("./Table.styles");
var _theme = require("../utils/theme");
var _IconButton = require("../IconButton");
var _AsyncComponent = require("../AsyncComponent");
var _CheckButton = require("../CheckButton");
var _Card = require("../Card");
var _LoadingAnimation = require("../LoadingAnimation");
var _excluded = ["selectable", "onSelectedItemsChange", "initialSelectedItems", "theme", "loading", "options", "elevation", "emptyState", "onClick", "children", "data", "columns", "reportTitle", "hasExportMenu", "title", "titleMinWidth", "actions", "content", "dense", "showPageJump", "showPageSizeOptions", "itemMargin", "itemPadding", "cellAlt", "scrollable"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LoadingSpinner = function LoadingSpinner(_ref) {
  var loading = _ref.loading;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('-loading', {
      'active -active': loading
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "spinner",
    style: {
      top: '0'
    }
  }, /*#__PURE__*/_react["default"].createElement(_LoadingAnimation.LoadingAnimation, {
    width: 60,
    height: 60
  })));
};
var defaultOptions = {
  LoadingComponent: LoadingSpinner,
  showPagination: false,
  showPaginationBottom: false,
  showPageSizeOptions: false,
  resizable: false,
  minRows: 0
};
var Table = function Table(_ref2) {
  var _ref2$selectable = _ref2.selectable,
    selectable = _ref2$selectable === void 0 ? false : _ref2$selectable,
    _ref2$onSelectedItems = _ref2.onSelectedItemsChange,
    onSelectedItemsChange = _ref2$onSelectedItems === void 0 ? _helpers.identity : _ref2$onSelectedItems,
    _ref2$initialSelected = _ref2.initialSelectedItems,
    initialSelectedItems = _ref2$initialSelected === void 0 ? [] : _ref2$initialSelected,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? _theme.defaultTheme : _ref2$theme,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? {} : _ref2$options,
    _ref2$elevation = _ref2.elevation,
    elevation = _ref2$elevation === void 0 ? 'none' : _ref2$elevation,
    emptyState = _ref2.emptyState,
    _ref2$onClick = _ref2.onClick,
    _onClick = _ref2$onClick === void 0 ? _helpers.identity : _ref2$onClick,
    children = _ref2.children,
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? [] : _ref2$data,
    columns = _ref2.columns,
    _ref2$reportTitle = _ref2.reportTitle,
    reportTitle = _ref2$reportTitle === void 0 ? 'Report' : _ref2$reportTitle,
    _ref2$hasExportMenu = _ref2.hasExportMenu,
    hasExportMenu = _ref2$hasExportMenu === void 0 ? true : _ref2$hasExportMenu,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? null : _ref2$title,
    titleMinWidth = _ref2.titleMinWidth,
    _ref2$actions = _ref2.actions,
    actions = _ref2$actions === void 0 ? null : _ref2$actions,
    _ref2$content = _ref2.content,
    content = _ref2$content === void 0 ? null : _ref2$content,
    _ref2$dense = _ref2.dense,
    dense = _ref2$dense === void 0 ? false : _ref2$dense,
    _ref2$showPageJump = _ref2.showPageJump,
    showPageJump = _ref2$showPageJump === void 0 ? false : _ref2$showPageJump,
    _ref2$showPageSizeOpt = _ref2.showPageSizeOptions,
    showPageSizeOptions = _ref2$showPageSizeOpt === void 0 ? false : _ref2$showPageSizeOpt,
    itemMargin = _ref2.itemMargin,
    itemPadding = _ref2.itemPadding,
    cellAlt = _ref2.cellAlt,
    _ref2$scrollable = _ref2.scrollable,
    scrollable = _ref2$scrollable === void 0 ? false : _ref2$scrollable,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = (0, _react.useState)( /*#__PURE__*/_react["default"].createRef()),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    reference = _useState4[0],
    setReference = _useState4[1];
  var _useState5 = (0, _react.useState)( /*#__PURE__*/_react["default"].createRef()),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    csvLink = _useState6[0],
    setCsvLink = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    downloadableCSVData = _useState8[0],
    setDownloadableCSVData = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    downloadError = _useState10[0],
    setDownloadError = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    loadingDownload = _useState12[0],
    setLoadingDownload = _useState12[1];
  var _useState13 = (0, _react.useState)(initialSelectedItems),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    selectedItems = _useState14[0],
    setSelectedItems = _useState14[1];
  var getColumns = function getColumns() {
    return selectable ? [{
      Header: /*#__PURE__*/_react["default"].createElement("div", {
        className: "foo",
        style: {
          margin: '-2px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CheckButton.CheckButton, {
        htmlFor: "".concat(title, "-SelectAll"),
        checked: selectedItems.length === data.length,
        onChange: function onChange(checked) {
          if (checked) {
            setSelectedItems((0, _toConsumableArray2["default"])(data));
          } else {
            setSelectedItems([]);
          }
        }
      })),
      width: 35,
      Cell: function Cell(p) {
        return /*#__PURE__*/_react["default"].createElement(_CheckButton.CheckButton, {
          htmlFor: "".concat(JSON.stringify(p.original), "-").concat(title),
          checked: selectedItems.findIndex(function (i) {
            return JSON.stringify(i) === JSON.stringify(p.original);
          }) !== -1,
          onChange: function onChange(checked) {
            if (checked) {
              setSelectedItems([p.original].concat((0, _toConsumableArray2["default"])(selectedItems)));
            } else {
              setSelectedItems(selectedItems.filter(function (i) {
                return JSON.stringify(i) !== JSON.stringify(p.original);
              }));
            }
          }
        });
      }
    }].concat((0, _toConsumableArray2["default"])(columns)) : columns;
  };
  var handleDownloadButton = function handleDownloadButton() {
    var currentRecords = reference.getResolvedState().sortedData;
    var dataToDownload = currentRecords.reduce(function (acc, curr) {
      var record = {};
      columns.map(function (col) {
        return record[col.Header] = curr[col.accessor];
      });
      acc.push(record);
      return acc;
    }, []);
    setDownloadableCSVData((0, _toConsumableArray2["default"])(dataToDownload));
  };
  var handleDownloadPDFButton = function handleDownloadPDFButton() {
    var doc = new _jspdf["default"]('l');
    var currentRecords = reference.getResolvedState().sortedData;
    var colsNames = columns.map(function (col) {
      return col.Header;
    });
    var dataToDownload = currentRecords.reduce(function (acc, curr) {
      var record = [];
      columns.map(function (col) {
        return record.push(curr[col.accessor]);
      });
      acc.push(record);
      return acc;
    }, []);
    doc.addImage("data:image/jpeg;base64,".concat(_mock.imgBase64), 'JPEG', 15, 50, 40, 40);
    doc.setFontSize(50);
    doc.text(reportTitle, 15, 130);
    doc.setFontSize(18);
    doc.text(new Date().toLocaleString(), 15, 142);
    doc.addPage();
    doc.setFontSize(14);
    doc.autoTable(colsNames, dataToDownload, {
      styles: {
        overflow: 'linebreak'
      }
    });
    var pageCount = doc.internal.getNumberOfPages();
    for (var i = 0; i < pageCount; i++) {
      doc.setPage(i);
      if (doc.internal.getCurrentPageInfo().pageNumber !== 1) {
        doc.text(280, 200, "".concat(doc.internal.getCurrentPageInfo().pageNumber, "/").concat(pageCount));
      }
    }
    doc.save('Reports.pdf', {
      returnPromise: true
    }).then(function () {
      return setLoadingDownload(false);
    })["catch"](function (err) {
      setDownloadError(err);
      setLoadingDownload(false);
    });
  };
  (0, _react.useEffect)(function () {
    if (downloadableCSVData.length > 0) {
      csvLink.link.click();
      setLoadingDownload(false);
    }
  }, [downloadableCSVData]);
  (0, _react.useEffect)(function () {
    onSelectedItemsChange(selectedItems);
  }, [selectedItems]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactCsv.CSVLink, {
    data: downloadableCSVData,
    filename: "Reports.csv",
    className: "hidden",
    ref: function ref(r) {
      return setCsvLink(r);
    },
    target: "_blank"
  }), /*#__PURE__*/_react["default"].createElement(_Card.Card, {
    padding: dense ? '0' : '16px',
    title: title,
    titleMinWidth: titleMinWidth,
    actions: actions
  }, content != null && content, /*#__PURE__*/_react["default"].createElement(_Table.PlainTable, (0, _extends2["default"])({
    ref: function ref(r) {
      return setReference(r);
    },
    data: data,
    columns: getColumns(),
    loading: loading,
    elevation: elevation,
    showPageJump: showPageJump,
    showPageSizeOptions: showPageSizeOptions,
    hasClick: _onClick !== _helpers.identity,
    itemPadding: itemPadding,
    itemMargin: itemMargin,
    scrollable: scrollable,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          title: cellAlt,
          onClick: function onClick(e) {
            if (!selectable) {
              setSelected(rowInfo.index);
              _onClick({
                row: rowInfo,
                event: e
              });
            } else if (selectedItems.findIndex(function (i) {
              return JSON.stringify(i) === JSON.stringify(rowInfo.original);
            }) === -1) {
              setSelectedItems([rowInfo.original].concat((0, _toConsumableArray2["default"])(selectedItems)));
            } else {
              setSelectedItems(selectedItems.filter(function (i) {
                return JSON.stringify(i) !== JSON.stringify(rowInfo.original);
              }));
            }
          },
          style: {
            background: rowInfo.index === selected && _onClick !== _helpers.identity ? theme.color.primary.translucid : rowInfo.index % 2 === 0 ? theme.color.primary.clear : 'white',
            borderRadius: '8px'
          }
        };
      }
      return {
        title: cellAlt
      };
    },
    PreviousComponent: function PreviousComponent(_ref3) {
      var disabled = _ref3.disabled,
        onClick = _ref3.onClick;
      return /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
        size: 35,
        padding: "8px",
        icon: "arrow-left",
        color: theme.color.primary["default"],
        type: "round",
        title: "Previous Page",
        disabled: disabled,
        onClick: onClick
      });
    },
    NextComponent: function NextComponent(_ref4) {
      var disabled = _ref4.disabled,
        onClick = _ref4.onClick;
      return /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
        size: 35,
        style: {
          padding: '8px'
        },
        icon: "arrow-right",
        color: theme.color.primary["default"],
        title: "Next Page",
        type: "round",
        disabled: disabled,
        onClick: onClick
      });
    },
    NoDataComponent: emptyState ? function () {
      return emptyState;
    } : undefined
  }, props, Object.assign(defaultOptions, options)))), hasExportMenu && /*#__PURE__*/_react["default"].createElement(_Table.ExportsRow, null, /*#__PURE__*/_react["default"].createElement(_AsyncComponent.AsyncComponent, {
    loading: loadingDownload,
    error: downloadError,
    component: /*#__PURE__*/_react["default"].createElement(_Table.CustomRow, null, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
      icon: "report",
      onClick: function onClick() {
        setLoadingDownload(true);
        handleDownloadButton();
      },
      color: theme.color.primary["default"],
      format: "round",
      size: "20"
    }), /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
      icon: "clipboard",
      onClick: function onClick() {
        setLoadingDownload(true);
        handleDownloadPDFButton();
      },
      color: theme.color.primary["default"],
      format: "round",
      size: "20"
    }))
  }))));
};
var _default = exports["default"] = Table;